<template>
  <div class="dialog">
    <el-dialog title="设置"
               :visible.sync="visible"
               :lock-scroll="true"
               width="818px"
               :before-close="handleClose">
      <el-form ref="form"
               :model="form"
               :inline="true"
               style="text-align: left"
               label-width="140px">
        <el-row class="reject-c">
          <el-form-item prop="deliverControl"
                        label="发货">
            <el-radio-group v-model="form.deliverControl">
              <el-radio :label="0">独立发货</el-radio>
              <el-radio :label="1">统一发货</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-row>
        <el-row class="reject-c">
          <el-form-item prop="afterSalesControl"
                        label="售后">
            <el-radio-group v-model="form.afterSalesControl">
              <el-radio :label="0">独立售后</el-radio>
              <el-radio :label="1">统一售后</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-row>
        <el-row class="reject-c">
          <el-form-item prop="customerControl"
                        label="客户">
            <el-radio-group v-model="form.customerControl">
              <el-radio :label="0">部门可见</el-radio>
              <el-radio :label="1">部门、公司可见</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-row>
        <el-row class="reject-c">
          <el-form-item prop="withdrawalControl"
                        label="提现">
            <el-radio-group v-model="form.withdrawalControl">
              <el-radio :label="0">独立提现</el-radio>
              <el-radio :label="1">统一提现</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-row>
      </el-form>
      <div class="btnBox">
        <el-button size="small"
                   @click="handleClose">取消</el-button>
        <el-button type="primary"
                   size="small"
                   @click="submit">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

import { salesAuthUpdate, salesAuthAdd } from "@/api/externalSalesRule";


export default {
  components: {

  },
  props: {
    btnType: {
      type: String,
      default: ''
    },
  },
  computed: {
    visible () {
      return this.dialogShow
    }
  },
  data () {
    return {
      dialogShow: false,
      isDisabled: false,
      pageType: '',
      info: {},
      form: {
      },
    }
  },
  mounted () {

  },
  methods: {
    init (row, type) {
      this.form = row;
      this.pageType = type;
      this.dialogShow = true;
      this.$forceUpdate();
    },
    submit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          let params = {
            shopId: this.form.shopId,
            shopName: this.form.shopName,
            deliverControl: this.form.deliverControl,
            afterSalesControl: this.form.afterSalesControl,
            customerControl: this.form.customerControl,
            withdrawalControl: this.form.withdrawalControl
          }
          if (this.pageType == 'edit') {
            params.id = this.form.id;
            salesAuthUpdate(params).then((res) => {
              if (res) {
                this.$message.success('提交成功');
                this.handleClose();
              } else {
                this.$message.error(res.msg)
              }
            })
          } else {
            salesAuthAdd(params).then((res) => {
              if (res) {
                this.$message.success('提交成功');
                this.handleClose();
              } else {
                this.$message.error(res.msg)
              }
            })
          }

        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleClose () {
      this.dialogShow = false;
    },
  }
}
</script>
<style lang="scss">
.btnBox {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.serach {
  margin-bottom: 10px;
}

.goods-content {
  max-height: 70vh;
  overflow-y: auto;
}

.goodList {
  display: flex;
  justify-content: space-around;

  &:nth-child(3n) {
    margin-right: 0px;
  }

  .img-div {
    height: 88px;
    width: 88px;
    margin: 0 10px;

    image {
      width: 100%;
      height: 100%;
    }
  }

  .l {
    width: 100%;
    height: 100%;
    border-radius: 4px;
    object-fit: cover;
  }

  .r {
    width: 214px;
    display: flex;
    flex: 1;
    flex-direction: column;

    div {
      display: flex;
    }

    span {
      font-size: 13px;
      color: #333;
      //margin-top: 10px;
    }

    .name {
      text-align: left;
      font-size: 16px;
      font-weight: 600;
      color: var(--color-26);
    }

    .rr {
      text-align: left;
      color: var(--color-59);
      font-size: 14px;
    }
  }

  &:hover {
    //  border: 2px solid var(--main-color) !important;
  }
}

.reject-c {
  margin-top: 10px;

  .title {
    line-height: 30px;
  }
}
</style>